import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import Spinner from '../../../components/Widgets/spinner';
import SpinnerButton from '../../Common/SpinnerButton';
import ImageFormatter from '../../Common/ImageFormatter';

import {
  fetchBolImage,
  deleteBolImage,
  submitBolImage,
  submitBolImageSCM,
  deleteBolImageSCM,
  fetchBolImageOCM,
} from '../../../actions/sales_actions';

import {
  isTN
} from '../../../actions/root_url';

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');



const propTypes = {
  rowKey: PropTypes.string,
  salesOrder_id: PropTypes.number,
  handleImageClosed: PropTypes.func,
};

const defaultProps = {
  rowKey: 'Index',
  salesOrder_id: undefined,
  handleImageClosed: () => {},
};

class BolImagesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldImage: {
        rows: [],
        selectedRows: null,
      },
      newImage: {
        rows: [],
        selectedRows: null,
      },

      isLoadingImages: false,
      isSavingImages: false,
      isDeletingImage: false,
    };
  }

  componentDidMount() {
    this.fetchImages();
  }

  onDrop = (row, files) => {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      
      const newRows = [...this.state.newImage.rows];
      newRows[index].imageString = reader.result;
      newRows[index].file = files;
      
      const newImage = {
        ...this.state.newImage,
        rows: newRows,
      };
      this.setState({ newImage });
    };
    
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  handleSaveImages = () => {
    const rows = this.state.newImage.rows.filter((row) => {
      const match = !(row.imageString === undefined);
      return match;
    });
    const newImage = {
      ...this.state.newImage,
      rows,
    };
    this.setState({ newImage }, () => {
      this.saveImages(() => {
        this.fetchImages();
      });
    });
  }

  addNewImageRow = (e) => {
    e.preventDefault();
    const rows = Data.Selectors.getRows(this.state.newImage);
    const index = rows.length;
    const newRow = {
      Index: index,
    };
    rows.push(newRow);
    const newImage = {
      ...this.state.newImage,
      rows,
    };
    this.setState({ newImage });
  }

  deleteOldRow = () => {
    const { selectedRows } = this.state.oldImage;
    if (!selectedRows || selectedRows.length === 0) {
      alert('Select a row to delete!');
      return;
    }
    const { Image_id: id } = selectedRows[0];
    this.deleteImage(id, () => this.fetchImages());
  }
  
  deleteImage = (imageId, successCallback) => {
    const handleSuccess = (response) => {
      this.setState({
        isDeletingImage: false,
      }, successCallback);
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        isDeletingImage: false,
      });
    };
    this.setState({
      isDeletingImage: true,
    }, () => {
      if(isTN) {
        deleteBolImageSCM(imageId, handleSuccess, handleFailure)
      } else {
        deleteBolImage(imageId, handleSuccess, handleFailure)
      }
    });
  }
  
  deleteNewRow = () => {
    const { selectedRows } = this.state.newImage;
    if (!selectedRows || selectedRows.length === 0) {
      alert('Select a row to delete!');
      return;
    }
    const rows = [...this.state.newImage.rows];
    const index = _.findIndex(rows, { Index: selectedRows[0].Index });
    rows.map((row, rowIndex) => {
      row.Index = rowIndex;
    });
    rows.splice(index, 1);
    const newImage = {
      ...this.state.newImage,
      rows,
    };
    this.setState({ newImage });
  }
  
  fetchImages = () => {
    const handleSuccess = (response) => {
      let rows = response.OrderImages || [];
      if (isTN) {
        rows = response.Images;
      }
      rows.map((row, index) => {
        row.Index = index;
      });
      const oldImage = {
        ...this.state.oldImage,
        rows,
      };
      this.setState({
        oldImage,
        isLoadingImages: false,
      });
    };
    const handleFailure = (error) => {
      alert(error);
      const oldImage = {
        ...this.state.oldImage,
        rows,
      };
      this.setState({
        oldImage,
        isLoadingImages: false,
      });
    };
    this.setState({
      isLoadingImages: true,
    }, () => {
      if (isTN) {
        fetchBolImageOCM(this.props.salesOrder_id, handleSuccess, handleFailure)
      } else {
        fetchBolImage(this.props.salesOrder_id, handleSuccess, handleFailure)
      }
    });
  }

  saveImages = (successCallback) => {
    const handleSuccess = (response) => {
      alert('Image is submit! ');
      this.setState({
        isSavingImages: false,
      }, successCallback);
      this.props.handleImageClosed();
    };
    const handleFailure = (error) => {
      let msg = "Error: ";
      msg += JSON.stringify(error);
      alert(msg);
      this.setState({
        isSavingImages: false,
      });
    };
    this.setState({
      isSavingImages: true,
    }, () => {
      if(isTN) {
        submitBolImageSCM(this.props.salesOrder_id, this.state.newImage.rows, handleSuccess, handleFailure)
      } else {
        submitBolImage(this.props.salesOrder_id, this.state.newImage.rows, handleSuccess, handleFailure)
      }
    });
  }

  renderNewImage = (index) => {
    const imageFile = (this.state.newImage.rows[index].imageString || '/img/dummy.png');
    return (
      <div className="img-view">
        <img
          src={imageFile}
          alt="Upload"
          className="default-image"
        />
      </div>
    );
  }

  renderImageTable() {
    const getRows = () => Data.Selectors.getRows(this.state.oldImage);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      const oldImage = {
        ...this.state.oldImage,
        rows,
      };
      this.setState({ oldImage });
      
      // // merge updated row with current row and rerender by setting state
      // const rows = getRows();
      // const editedRows = this.state.editedRows.slice(0);
      // Object.assign(rows[e.rowIdx], e.updated);
      // // if the element is already edited, remove the old one.
      // editedRows.forEach((element, index) => {
      //   if (element.Idx === rows[e.rowIdx].Index) {
      //     editedRows.splice(index, 1);
      //   }
      // }, this);
      // // push the row into the editedRows array
      // editedRows.push(rows[e.rowIdx]);
      // this.setState({
      //   rows,
      //   editedRows,
      // });
    };
    
    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const oldImage = {
        ...this.state.oldImage,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      this.setState({
        oldImage,
      });
    };
    
    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const oldImage = {
        ...this.state.oldImage,
        rows: newRows,
        selectedRows: []
      };
      this.setState({ oldImage });
    };


    const columns = [
      {
        key: "ImageURL",
        name: <Translate value="image" />,
        resizeable: true,
        width: 220,
        sortable: false,
        editable: false,
        filterable: false,
        formatter: ({ value }) => (
          <div className="group-thumbnail-cell">
            <div id="image-container">
              <img style={{width: "120px", height: "120px", border: "1px solid #333333"}} src={value}/>
            </div>
          </div>
        ),
        getRowMetaData: (row) => row,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: "100%" }} id="Category_2-dataGrid1">
            <DraggableContainer>
              <ReactDataGrid
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={500}
                rowHeight={200}
                headerRowHeight={25}
                enableRowSelect="single"
                onRowUpdated={handleRowUpdated}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </DraggableContainer>
          </div>
        </Col>
      </Row>
    );
  }


  renderNewImageTable() {
    
    const getRows = () => Data.Selectors.getRows(this.state.newImage);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      const newImage = {
        ...this.state.newImage,
        rows,
      };
      this.setState({ newImage });
    };
    
    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const newImage = {
        ...this.state.newImage,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      this.setState({ newImage });
    };
    
    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const newImage = {
        ...this.state.newImage,
        rows: newRows,
        selectedRows: [],
      };
      this.setState({ newImage });
    };


    const columns = [
      {
        key: "Image",
        name: <Translate value="image" />,
        resizeable: true,
        width: 220,
        sortable: false,
        editable: false,
        filterable: false,
        formatter: (
          <ImageFormatter
            renderImage={this.renderNewImage}
            onDrop={this.onDrop}
            showImageOnly={true}
            onRowValueChange={this.onRowValueChange}
          />
        ),
        getRowMetaData: (row) => row,
      },
    ];
    
    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: "100%" }} id="Category_2-dataGrid1">
            <DraggableContainer>
              <ReactDataGrid
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={500}
                rowHeight={200}
                headerRowHeight={25}
                enableRowSelect="single"
                onRowUpdated={handleRowUpdated}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </DraggableContainer>
          </div>
        </Col>
      </Row>
    );
  }
  
  render() {
    const { isSavingImages, isDeletingImage } = this.state;
    return (
      <ContentWrapper>
        <div id="product-images-modal">
          {/* old image table */}
          <div style={{ width: "50%", float: 'left' }}>
            <div className="toolbar-row">
              <ButtonToolbar>
                <SpinnerButton
                  bsStyle="danger"
                  disabled={isDeletingImage}
                  onClick={this.deleteOldRow}
                  loading={isDeletingImage}
                  icon="fa-trash"
                  translation={<Translate value="delete" />}
                />
              </ButtonToolbar>
            </div>
            {/* <br /> */}
            {this.renderImageTable()}
          </div>
          {/* new image table */}
          <div style={{ width: "50%", float: 'left' }}>
            {/* <br /> */}
            <div className="toolbar-row">
              <ButtonToolbar>
                <Button
                  bsStyle="primary"
                  onClick={this.addNewImageRow}
                >
                  <em className="fa fa-plus" /><Translate value="create" />
                </Button>
                <SpinnerButton
                  bsStyle="success"
                  disabled={isSavingImages}
                  onClick={this.handleSaveImages}
                  loading={isSavingImages}
                  icon="fa-save"
                  translation={<Translate value="save" />}
                />
                <SpinnerButton
                  bsStyle="danger"
                  onClick={this.deleteNewRow}
                  icon="fa-trash"
                  translation={<Translate value="delete" />}
                />
              </ButtonToolbar>
            </div>
            {this.renderNewImageTable()}
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

BolImagesTable.propTypes = propTypes;
BolImagesTable.defaultProps = defaultProps;

export default BolImagesTable;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/BolImagesTable.jsx